/**
 * Web版のファイルダウンロード機能
 * Electronのsave dialogの代替として、ブラウザのダウンロード機能を使用
 */

import logger from './logger';

/**
 * ファイルをダウンロードする
 * @param content ファイル内容
 * @param filename ファイル名
 * @param mimeType MIMEタイプ
 */
export function downloadFile(content: string, filename: string, mimeType: string = 'text/plain'): void {
  try {
    // BlobとObjectURLを使用してダウンロードを実行
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);

    // ダウンロードリンクを作成
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    // クリックイベントを発火してダウンロード
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // メモリリークを防ぐためURLを解放
    setTimeout(() => URL.revokeObjectURL(url), 100);

    logger.info('[webFileDownload] File downloaded:', { filename, size: content.length });
  } catch (error) {
    logger.error('[webFileDownload] Failed to download file:', error);
    throw error;
  }
}

/**
 * HTMLファイルをダウンロードする
 * @param htmlContent HTML内容
 * @param filename ファイル名（拡張子なしでも可）
 */
export function downloadHtmlFile(htmlContent: string, filename: string): void {
  const fullFilename = filename.endsWith('.html') ? filename : `${filename}.html`;
  downloadFile(htmlContent, fullFilename, 'text/html;charset=utf-8');
}

/**
 * SVGファイルをダウンロードする
 * @param svgContent SVG内容
 * @param filename ファイル名（拡張子なしでも可）
 */
export function downloadSvgFile(svgContent: string, filename: string): void {
  const fullFilename = filename.endsWith('.svg') ? filename : `${filename}.svg`;
  downloadFile(svgContent, fullFilename, 'image/svg+xml;charset=utf-8');
}

/**
 * CSVファイルをダウンロードする
 * @param csvContent CSV内容
 * @param filename ファイル名（拡張子なしでも可）
 */
export function downloadCsvFile(csvContent: string, filename: string): void {
  const fullFilename = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  downloadFile(csvContent, fullFilename, 'text/csv;charset=utf-8');
}